<script lang="ts" setup>
import HistoryChart from "@/components/history/HistoryChart.vue";
import HistoryOperationsList from "@/components/history/HistoryOperationsList.vue";
import BaseIcon from "@/components/base/BaseIcon.vue";
import { useHistoryOperations } from "@/composables/history/useHistoryOperations";
const {
  activeTab,
  choosePeriod,
  filteredOperations,
  getOperationIcon,
  getOperationIconAlt,
  getOperationMeta,
  getOperationSubtitle,
  getOperationTitle,
  getOperationValue,
  isCustomPeriod,
  isOpenedSelect,
  openSelect,
  operationsTabs,
  periodOptions,
  periodText,
  resetPeriod,
  selectTab,
  selectedPeriod,
  totalSum,
  totalUnit,
} = useHistoryOperations();
</script>

<template>
  <div class="history-body__summary">
    <div class="history-body__summary-header">
      <div class="history-body__summary-header_period" @click.stop="openSelect">
        <p class="caption-large--bold color-grey-light">
          {{ periodText }}
        </p>
        <div class="arrow-box color-grey-light">
          <BaseIcon
            v-if="isCustomPeriod"
            name="close"
            @click.stop="resetPeriod()"
          />
          <BaseIcon
            v-else
            name="service-arrow"
            :position="isOpenedSelect ? 'top' : 'bottom'"
            @click.stop="openSelect"
          />
        </div>
        <div class="period-select" :class="{ open: isOpenedSelect }">
          <div
            v-for="option in periodOptions"
            :key="option.value"
            class="period-select__item"
            @click.stop="choosePeriod(option.value)"
          >
            {{ option.label }}
          </div>
        </div>
      </div>
      <div class="history-body__summary-header_tabs">
        <div
          v-for="(item, index) in operationsTabs"
          :key="index"
          class="history-body__summary-header_tabs-item"
          :class="{ active: item.active }"
          @click="selectTab(item.key)"
        >
          <p class="caption-navbar color-grey-light">
            {{ item.title }}
          </p>
        </div>
      </div>
    </div>
    <div class="history-body__summary-sum">
      <p class="h1">{{ totalSum }} {{ totalUnit }}</p>
    </div>
    <HistoryChart
      :period="selectedPeriod"
      :operations="filteredOperations"
      :active-tab="activeTab"
    />
  </div>
  <HistoryOperationsList
    :operations="filteredOperations"
    :get-operation-icon="getOperationIcon"
    :get-operation-icon-alt="getOperationIconAlt"
    :get-operation-title="getOperationTitle"
    :get-operation-subtitle="getOperationSubtitle"
    :get-operation-value="getOperationValue"
    :get-operation-meta="getOperationMeta"
  />
</template>

<style lang="scss" scoped>
@import "@/assets/style/components/history-operations";
</style>
